import './js/global'
import './js/header'

// Blocks.
import './js/block/gallery'
import './js/block/text-image-button'
import './js/block/steps-list'
import './js/block/steps-slider'
import './js/block/vehicle-price'
import './js/block/vehicle-range'

// Elements.

// Headers.
import './js/header/header-vehicle'
import './js/header/header-vehicle-range'
import './js/header/header-simulator'

// Pages.
import './js/pages/usecase'
import './js/pages/contact'

// Single.

// Parts.
import './js/part/hero-cta'
import './js/part/simulator'
